import React from 'react';
import PropTypes from 'prop-types';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import {
    Col,
} from '@zillow/zrs-comet';

import ThumbItem from 'app/shared/components/postingPath/ThumbItem';

import {
    StyledSortableListRow,
} from './StyledComponents';

const propTypes = {
    isListingPhotoProcessing: PropTypes.bool.isRequired,
    isMobileScreenResolution: PropTypes.bool.isRequired,
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
    // actions
    onSortEnd: PropTypes.func.isRequired,
    removePhoto: PropTypes.func.isRequired,
    rotatePhoto: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
};

const SETTINGS = {
    // num px to be dragged before element becomes sortable
    DISTANCE: 5,
};

function ThumbList({
    isListingPhotoProcessing,
    isMobileScreenResolution,
    list,
    // actions
    handleItemClick,
    onSortEnd,
    removePhoto,
    rotatePhoto,
    isDisabled,
}) {
    const shouldCancelStart = (event) => {
        let isClose = false;

        if (event.target &&
            event.target.classList &&
            event.target.classList[1] === 'close'
        ) {
            isClose = true;
        }

        return isListingPhotoProcessing || isMobileScreenResolution || isClose;
    };

    // handlers
    const handleOnSortEnd = ({ oldIndex, newIndex }) => {
        onSortEnd({ oldIndex, newIndex });
    };

    const thisHandleItemClick = (index) => {
        handleItemClick(index);
    };

    const handleNextClick = (index) => {
        const oldIndex = index;
        const newIndex = index + 1 > list.length - 1 ? 0 : index + 1;

        onSortEnd({ oldIndex, newIndex });
    };

    const handlePrevClick = (index) => {
        const oldIndex = index;
        const newIndex = index - 1 < 0 ? list.length - 1 : index - 1;

        onSortEnd({ oldIndex, newIndex });
    };

    const handleRemovePhotoClick = (index) => {
        if (!isDisabled) {
            removePhoto(index);
        }
    };

    const handleRotatePhoto = (index) => {
        rotatePhoto(index);
    };

    // sortable hoc
    const SortableItem = SortableElement(({
        item,
        isFirstItem,
        isLastItem,
        sortIndex,
    }) => (
        <Col
            key={sortIndex}
            xs={6}
            md={4}
            lg={3}
        >
            <ThumbItem
                index={sortIndex}
                isMobileScreenResolution={isMobileScreenResolution}
                item={item}
                isFirstItem={isFirstItem}
                isLastItem={isLastItem}
                isListingPhotoProcessing={isListingPhotoProcessing}
                isDisabled={isDisabled}
                // actions
                handleItemClick={thisHandleItemClick}
                handleNextClick={handleNextClick}
                handlePrevClick={handlePrevClick}
                removePhoto={handleRemovePhotoClick}
                rotatePhoto={handleRotatePhoto}
            />
        </Col>
    ));

    const SortableList = SortableContainer(({ className, items }) => (
        <StyledSortableListRow className={className}>
            {items.map((item, index) => {
                const isFirstItem = index === 0;
                const isLastItem = index === items.length - 1;

                return (
                    <SortableItem
                        key={`item-${index}`}
                        index={index}
                        sortIndex={index}
                        item={item}
                        isFirstItem={isFirstItem}
                        isLastItem={isLastItem}
                    />
                );
            })}
        </StyledSortableListRow>
    ));

    return (
        <div className="ThumbList">
            <SortableList
                className="SortableList"
                axis="xy"
                // distance cannot be used in conjunction with the pressDelay prop
                distance={SETTINGS.DISTANCE}
                hideSortableGhost={true}
                items={list}
                lockToContainerEdges={true}
                shouldCancelStart={shouldCancelStart}
                useDragHandle={false}
                // actions
                onSortEnd={handleOnSortEnd}
            />
        </div>
    );
}

ThumbList.propTypes = propTypes;
export default ThumbList;
